import { clamp } from 'lodash';
import { longWaitTimeText, shortWaitTimeText, waitTimeText } from './content';

const WAIT_TIME_DELTA = 5;
const WAIT_TIME_MIN = 0;
const WAIT_TIME_MAX = 10;
const WAIT_TIME_SHORT = 1;

/**
 * Given a number, round the number to the nearest multiple of `step`
 * @param x the number to be rounded
 * @param step the number the result should be a multiple of
 * @returns a number rounded to the nearest `step`
 */
const roundToNearest = (x: number, step: number) => {
  return Math.round(x / step) * step;
};

export const getRoundedWait = (waitTime: number) => {
  return clamp(roundToNearest(waitTime, WAIT_TIME_DELTA), WAIT_TIME_MIN, WAIT_TIME_MAX);
};

/**
 * Gets the text that should display for the Name Form depending on the `waitTime`
 * @param waitTime
 * @returns the display text for the Name Form
 */
export const getWaitTimeText = (waitTime: number) => {
  if (waitTime <= WAIT_TIME_SHORT) {
    return shortWaitTimeText;
  } else if (waitTime > WAIT_TIME_MAX) {
    return longWaitTimeText;
  } else {
    return waitTimeText(getRoundedWait(waitTime));
  }
};
